import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { PageTitle } from '../../shared/components/page-title/page-title';
import { SuperConsoleNavigation } from './super-console-navigation/super-console-navigation';
import {TranslateSafePipe} from '../../shared/pipes/translation.pipe';

@Component({
  selector: 'app-super-console',
  imports: [
    PageTitle,
    RouterOutlet,
    SuperConsoleNavigation,
    TranslateSafePipe,
  ],
  templateUrl: './super-console.component.html',
  styleUrl: './super-console.component.css'
})
export class SuperConsoleComponent {

}
